<template>
  <q-page padding>
    <div class="relative-position loader">
      <company-export></company-export>
    </div>
  </q-page>
</template>

<script>
import CompanyExport from 'components/company/company-export'

export default {
  components: {CompanyExport },
  data: () => ({}),
  async created () {},
  computed: {},
  methods: {}
}
</script>
